var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFacebookIconinline = function SvgFacebookIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.624 26.665l.865-5.666h-5.437v-3.673c0-1.551.76-3.061 3.192-3.061h2.474V9.44s-2.245-.383-4.384-.383c-4.473 0-7.404 2.71-7.404 7.624v4.318h-4.971v5.666h4.971v13.69a19.864 19.864 0 006.122 0v-13.69h4.572z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2.24C10.64 2.24 2.24 10.64 2.24 21c0 10.36 8.4 18.758 18.76 18.758 10.36 0 18.758-8.399 18.758-18.759 0-10.36-8.399-18.758-18.759-18.758zM.573 21C.574 9.718 9.72.573 21 .573 32.28.574 41.425 9.72 41.425 21S32.28 41.426 20.999 41.426C9.72 41.425.574 32.28.574 20.999z"
  })));
};
export default SvgFacebookIconinline;